import {
  DASH_SET_DOCUMENTOS_FISCAIS_FAIL,
  DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  DASH_SET_ESTADO_INICIAL,
  DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_FAIL,
  DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS,
  DASH_SET_SEM_MANIFESTO_FAIL,
  DASH_SET_SEM_MANIFESTO_SUCCESS,
  DASH_SET_ULTIMA_CONSULTA_FAIL,
  DASH_SET_ULTIMA_CONSULTA_SUCCESS,
  DASH_SET_ULTIMA_SEMANA_FAIL,
  DASH_SET_ULTIMA_SEMANA_SUCCESS,
} from './types';
import box from '../api/box';
import { sendErroRequest } from '../utils/Notification';

const urlBaseDashboard = '/v1/dashboards';
const urlBaseHistoricoConsulta = '/v1/historicos-consulta';

const setDashboardDocumentoSuccess = values => ({
  type: DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  payload: values,
});

const setDashboardDocumentoFail = () => ({
  type: DASH_SET_DOCUMENTOS_FISCAIS_FAIL,
});

const setDashboardOrigemDocumentoSuccess = values => ({
  type: DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS,
  payload: values,
});

const setDashboardOrigemDocumentoFail = () => ({
  type: DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_FAIL,
});

const setDashboardUltimaSemanaSuccess = values => ({
  type: DASH_SET_ULTIMA_SEMANA_SUCCESS,
  payload: values,
});

const setDashboardUltimaSemanaFail = () => ({
  type: DASH_SET_ULTIMA_SEMANA_FAIL,
});

const setUltimaConsultaSuccess = values => ({
  type: DASH_SET_ULTIMA_CONSULTA_SUCCESS,
  payload: values,
});

const setUltimaConsultaFail = () => ({
  type: DASH_SET_ULTIMA_CONSULTA_FAIL,
});

const setTotalSemManifestoSuccess = values => ({
  type: DASH_SET_SEM_MANIFESTO_SUCCESS,
  payload: values,
});

const setTotalSemManifestoFail = () => ({
  type: DASH_SET_SEM_MANIFESTO_FAIL,
});

const getDashboardDocumento = (dataInicial, dataFinal) => async dispatch => {
  try {
    const { data } = await box.get(
      `${urlBaseDashboard}/documento-fiscal?dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
    );

    dispatch(setDashboardDocumentoSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados dos documentos fiscais');

    dispatch(setDashboardDocumentoFail());
  }
};

const getDashboardOrigemDocumento = (dataInicial, dataFinal) => async dispatch => {
  try {
    const { data } = await box.get(
      `${urlBaseDashboard}/origem?dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
    );

    dispatch(setDashboardOrigemDocumentoSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados da origem dos documentos fiscais');

    dispatch(setDashboardOrigemDocumentoFail());
  }
};

const getDashboardUltimaConsulta = cb => async dispatch => {
  try {
    const { data } = await box.get(`${urlBaseHistoricoConsulta}/ultima`);

    dispatch(setUltimaConsultaSuccess(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    if (error.response && error.response.status === 404) {
      dispatch(setUltimaConsultaSuccess(0));
    } else {
      sendErroRequest(error, 'Não foi possível buscar os dados da ultima consulta');

      dispatch(setUltimaConsultaFail());
    }

    if (cb && typeof cb === 'function') cb();
  }
};

const getUltimaSemana = (dataInicial, dataFinal) => async dispatch => {
  try {
    const { data } = await box.get(
      `${urlBaseDashboard}/ultima-semana?dataInicial=${dataInicial}&dataFinal=${dataFinal}`,
    );

    dispatch(setDashboardUltimaSemanaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados da ultima semana');

    dispatch(setDashboardUltimaSemanaFail());
  }
};

const getDashboardTotalSemManifesto = cb => async dispatch => {
  try {
    const { data } = await box.get(`${urlBaseDashboard}/total-sem-manifesto`);

    dispatch(setTotalSemManifestoSuccess(data));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar o total sem manifesto');

    dispatch(setTotalSemManifestoFail());

    if (cb && typeof cb === 'function') cb();
  }
};

export const getDashboardGeral = (
  dataInicial,
  dataFinal,
  cbManifesto,
  cbUltima,
) => async dispatch => {
  try {
    dispatch(getUltimaSemana(dataInicial, dataFinal));
    dispatch(getDashboardTotalSemManifesto(cbManifesto));
    dispatch(getDashboardUltimaConsulta(cbUltima));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados do dashboard geral');
  }
};

export const getDashboardMonth = (dataInicial, dataFinal) => async dispatch => {
  try {
    dispatch(getDashboardDocumento(dataInicial, dataFinal));
    dispatch(getDashboardOrigemDocumento(dataInicial, dataFinal));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados do dashboard mensal');
  }
};

export const setEstadoInicialDashboard = () => async dispatch => {
  dispatch({ type: DASH_SET_ESTADO_INICIAL });
};
